// Axios global configuration for cookie-based authentication
import axios from 'axios';

// Configure axios to send HTTP-only cookies with all requests
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export default axios;
